<sh-main-nav-single-item
  [item]="mainNavItemsService.newsfeedItem"
  (closeMenu)="onCloseMenu()"></sh-main-nav-single-item>

@if (loadedProfileSubscription$ | async; as profileSubscription) {
  <a
    target="_blank"
    [href]="knowledgeBaseURL">
    {{ 'tutorials.title' | transloco }}
  </a>
}
<!-- NOTE: it was requested to commented it out temporarly, before it will be removed - SH-3359 -->
<!-- <sh-main-nav-single-item
  [item]="items.topIndustriesItem"
  (closeMenu)="onCloseMenu()"></sh-main-nav-single-item> -->

<ng-container *ngIf="(mainNavService.hasProfile$ | async) === true">
  <sh-main-nav-profiles-mobile
    *ngIf="(mainNavService.profileWhereUserAdmin$ | async)?.length === 1; else severalProfiles"
    [profiles]="(mainNavService.profileWhereUserAdmin$ | async) ?? []"
    (closeMenu)="onCloseMenu()">
  </sh-main-nav-profiles-mobile>

  <ng-template #severalProfiles>
    <div
      class="nested-item"
      (click)="openProfiles()">
      <a
        data-cy="main-nav-our-products"
        [attr.title]="'header.profiles' | transloco">
        {{ 'header.profiles' | transloco }}
      </a>
      <ui-icon
        class="chevron"
        key="chevron-right"></ui-icon>
    </div>
  </ng-template>
</ng-container>

<a
  [attr.title]="'header.business-page' | transloco"
  [routerLink]="mainNavItemsService.businessPageRootLink"
  (click)="onCloseMenu()">
  <button
    class="nav-item-button"
    color="accent"
    mat-stroked-button>
    {{ 'header.business-page' | transloco }}
  </button>
</a>

<div
  class="nested-nav-item-list-for-mobile"
  *ngIf="(profilesOpen$ | async) === true">
  <div
    class="nested-nav-item-list-for-mobile-header"
    (click)="closeProfiles()">
    <ui-icon
      class="chevron"
      key="chevron-left"></ui-icon>
    <a>{{ 'header.profiles' | transloco }}</a>
  </div>

  <div class="nested-nav-item-list-for-mobile-list">
    <sh-main-nav-profiles-mobile
      [profiles]="(mainNavService.profileWhereUserAdmin$ | async) ?? []"
      (closeMenu)="onCloseMenu()">
    </sh-main-nav-profiles-mobile>

    @if (isSuperAdmin$ | async) {
      <a
        [attr.title]="'header.user-menu.create-new-profile' | transloco"
        (click)="createProfile()">
        {{ 'header.user-menu.create-new-profile' | transloco }}
      </a>
    }
  </div>
</div>
